import { useCommonServiceClientContext } from '@geneo2-web/shared-ui';
import { Module_ModuleCategoryEnum } from '@protos/content_management/content.db_pb';
import { useEffect, useState } from 'react';

export interface IModuleLockedInfoParams {
  subjectId: number;
  teacherProfileId?: bigint;
  category: Module_ModuleCategoryEnum;
  moduleId?: number;
  schoolClassSectionId?: number;
  lessonId?: string;
  isFeatureAvailable: boolean;
}

const useFetchLockedResourceIds = (params: IModuleLockedInfoParams) => {
  const {
    subjectId,
    teacherProfileId,
    category,
    moduleId,
    schoolClassSectionId,
    lessonId,
    isFeatureAvailable,
  } = params;
  const commonServiceClientContext = useCommonServiceClientContext();
  const { LmsCommonAPIServiceV1ClientWithStatusCodeHandler } =
    commonServiceClientContext;
  const [lockedResourceIds, setLockedResourceIds] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const studentModuleLockInfoFetch = async () => {
    try {
      setError(false);
      setLoading(true);
      const response =
        await LmsCommonAPIServiceV1ClientWithStatusCodeHandler.moduleLockInfoFetch(
          {
            subjectId: subjectId,
            teacherId: teacherProfileId,
            moduleId: moduleId,
            category: category,
            schoolClassSectionId: schoolClassSectionId,
          }
        );
      if (response?.data) {
        const data = response.data;
        if (data) {
          if (lessonId) {
            const lessonlockedResourceIds =
              data.moduleUpdatedLockInfo?.lessonsLockInfo.find(
                (e) => e.lessonId === lessonId
              )?.lockedResourceIds;
            setLockedResourceIds(lessonlockedResourceIds || []);
          } else {
            setLockedResourceIds(
              data.moduleUpdatedLockInfo?.lockedResourceIds || []
            );
          }
        }
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setError(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (teacherProfileId && moduleId && isFeatureAvailable) {
      studentModuleLockInfoFetch();
    }
  }, [lessonId, moduleId]);

  return { lockedResourceIds, loading, error };
};

export default useFetchLockedResourceIds;
